import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

export function firstValueFrom<T>(stream$: Observable<T>): Promise<T> {
  return stream$.pipe(take(1)).toPromise();
}
